import { Pipe, PipeTransform } from '@angular/core';
import * as utils from '@app/shared/utils';

@Pipe({
  name: '_cpf',
  pure: true,
})
export class CpfPipe implements PipeTransform {
  public transform(value: string): any {
    if (!value) {
      return;
    }
    return utils.formatCpf(value);
  }
}
